export default __webpack_public_path__ + "f044d228252bb0d2373618c27e5a262f.png";